<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12">
                <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('semester')">
                        <semesters-selectbox v-model="form.semester_id"
                                             :validate-error="errors[0]"></semesters-selectbox>
                    </b-form-group>
                </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="code" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('faculty')">
                                <faculty-selectbox v-model="form.faculty_code"
                                                   :validate-error="errors[0]"/>
                            </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="group_name" rules="required" v-slot="{ valid,errors }">
                        <b-form-group :label="$t('group_name')">
                            <b-form-input
                                v-model="form.group_name"
                                :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </b-row>
        </ValidationObserver>

        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import { ValidationProvider, ValidationObserver } from "vee-validate"
//Service
// Components
import MicrosoftTeamsGroupServices from "@/services/MicrosoftTeamsGroupServices";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formLoading: false,
            form: {
            },
        }
    },
    methods: {
        async createForm() {
            if (this.checkPermission('microsoftteamgroup_store')) {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    MicrosoftTeamsGroupServices.store(this.form)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$emit("createFormSuccess")
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        });
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
